import apiFn from 'common/services/api-service';

const api = (eventId, headers = { Accept: 'application/vnd.eventmobi+json; version=p.4' }) =>
  apiFn(`/api/uapi/events/${eventId}/people/fields`, headers);

export function list(eventId, extraParams = {}) {
  const headers = {};
  headers.Accept = 'application/vnd.eventmobi+json; version=p.7';

  const params = new URLSearchParams(extraParams);

  return api(eventId, headers)
    .get(null, { params })
    .then(response => response?.data?.data);
}

export function remove(eventId, fieldId) {
  return api(eventId)
    .delete(fieldId.toString())
    .then(response => response?.data?.data);
}

export function reorder(eventId, data) {
  const headers = {};
  headers.Accept = 'application/vnd.eventmobi+json; version=p.7';
  return apiFn(`/api/uapi/events/${eventId}/people/fields`, headers)
    .patch('', data)
    .then(response => response?.data?.data);
}

export function create(eventId, data) {
  const headers = {
    'x-nested-list-partial-updates': 'false',
  };
  headers.Accept = 'application/vnd.eventmobi+json; version=p.7';
  return apiFn(`/api/uapi/events/${eventId}/people/fields`, headers)
    .post('', data)
    .then(response => response?.data?.data);
}

export function update(
  eventId,
  fieldId,
  payload,
  { nestedListPartialUpdates } = { nestedListPartialUpdates: false },
) {
  const headers = {
    'x-nested-list-partial-updates': nestedListPartialUpdates ? 'true' : 'false',
  };
  headers.Accept = 'application/vnd.eventmobi+json; version=p.7';
  return apiFn(`/api/uapi/events/${eventId}/people/fields/${fieldId}`, headers)
    .patch('', payload)
    .then(response => response?.data?.data);
}
